import { parsePhoneNumberFromString } from 'libphonenumber-js'

export function parsePhoneNumber(string) {
  try {
    return parsePhoneNumberFromString(string)
  } catch (e) {
    return 0
  }
}
